import React from 'react';

export default class StatusBar extends React.Component {
  render() {
    return (
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 20,
        background: 'rgb(10, 125, 216)',
        padding: '5px 20px',
        borderTop: '1px solid rgb(1, 89, 158)',
        color: '#fff',
        fontWeight: '600'
      }}>
        {this.props.children}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./client/components/common/StatusBar.js